import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface INotebookProps extends IconPropsType {}

const NotebookIcon = ({
  size = 16,
  color = 'white',
  ...props
}: INotebookProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M11.5 7C11.5 7.13261 11.4473 7.25979 11.3536 7.35355C11.2598 7.44732 11.1326 7.5 11 7.5H7C6.86739 7.5 6.74021 7.44732 6.64645 7.35355C6.55268 7.25979 6.5 7.13261 6.5 7C6.5 6.86739 6.55268 6.74021 6.64645 6.64645C6.74021 6.55268 6.86739 6.5 7 6.5H11C11.1326 6.5 11.2598 6.55268 11.3536 6.64645C11.4473 6.74021 11.5 6.86739 11.5 7ZM11 8.5H7C6.86739 8.5 6.74021 8.55268 6.64645 8.64645C6.55268 8.74021 6.5 8.86739 6.5 9C6.5 9.13261 6.55268 9.25979 6.64645 9.35355C6.74021 9.44732 6.86739 9.5 7 9.5H11C11.1326 9.5 11.2598 9.44732 11.3536 9.35355C11.4473 9.25979 11.5 9.13261 11.5 9C11.5 8.86739 11.4473 8.74021 11.3536 8.64645C11.2598 8.55268 11.1326 8.5 11 8.5ZM14 3V13C14 13.2652 13.8946 13.5196 13.7071 13.7071C13.5196 13.8946 13.2652 14 13 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3ZM3 13H4.5V3H3V13ZM13 13V3H5.5V13H13Z"
      fill={color}
    />
  </svg>
);

export default NotebookIcon;
